import $ from "jquery"; // Import jQuery
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useRequiredFields from "../../../../../hooks/useRequiredFields";
import useFocusedRowHighlight from "../../../../../hooks/useFocusedRowHighlight";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import { LoaderComponent } from "../../../../Common/LoaderComponent";
import Select from "react-select";
import { ProgressSpinner } from "primereact/progressspinner";

const Create = () => {
  const { checkRequiredFields } = useRequiredFields();
  const { getRowProps } = useFocusedRowHighlight();
  const navigate = useNavigate();

  const [inputs, setInputs] = useState({
    receipt_no: "",
    production_work_order_id: "",
    date: "",
    receive_date: "",
    entry_date: new Date().toISOString().split("T")[0],
    copy_type: "",
    purchase_type: "",
    from_department: "",
    to_department: "",
    status: "requested",
    remarks: "",
    destination_id: "",
    do_no: "",
    vehicle_no: "",
    driver_name: "",
    gate_pass_no: "",
    decoration_name: "",
  });
  const [loading, setLoading] = useState(false);

  const [list, setList] = useState([]);
  const [error, setError] = useState({});
  const [product, setProduct] = useState([]);
  const [planningOptions, setPlanningOptions] = useState([]);
  const [role, setRole] = useState("");
  const [itemLoading, setItemLoading] = useState(false);
  const [searchProducts, setSearchProducts] = useState("");
  const [originalList, setOriginalList] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [planningImages, setPlanningImages] = useState([]);
  const [decorations, setDecorations] = useState([]);
  const [allItemsWithInput, setAllItemsWithInput] = useState(new Map());
  const [showPagination, setShowPagination] = useState(true);
  // Add this state near the top of your component with other useState declarations
  const [userSelectedDecorations, setUserSelectedDecorations] = useState(
    new Set(),
  );
  const [groupInventory, setGroupInventory] = useState(new Map());

  // Reference to store search timeout
  const searchTimeoutRef = useRef(null);

  const dummyDecorations = [
    "Gold Rim",
    "Platinum Rim",
    "Flower Design",
    "Leaf Pattern",
    "Textured Edge",
  ];

  const repairTypes = ["PH", "SS", "AIR", "PC"];
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 200,
    total: 0,
    last_page: 1,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async (page = 1) => {
    setLoading(true);

    try {
      const resRole = await Http.get("/staff-type-check");
      setRole(resRole.data);

      const resPlanning = await Http.get("/planning");
      const planningData = resPlanning.data;
      setPlanningOptions(planningData);

      if (planningData.length > 0) {
        const firstPlanning = planningData[0];
        setInputs((prevInputs) => ({
          ...prevInputs,
          planning_id: firstPlanning.id,
        }));

        handlePlanningChange(firstPlanning.id);
      }

      const resReceiptNo = await Http.get(
        "/last-code-increment-by-one/production_finished_goods/receipt_no/P",
      );
      const receiptNo = resReceiptNo.data;

      setInputs((prevInputs) => ({
        ...prevInputs,
        receipt_no: receiptNo,
      }));

      const resCompanies = await Http.get("/companies");
      setCompanies(resCompanies.data);

      const resPlanningImages = await Http.get("/planning-image");
      setPlanningImages(resPlanningImages.data);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  useEffect(() => {
    $("body").addClass("collapse-menu");
    fetchData();

    const fetchDecorations = async () => {
      try {
        const response = await Http.get("/planning-image");
        setDecorations(
          response.data.map((dec) => ({
            label: dec.code,
            value: dec.id,
            decoration_name: dec.decoration_name,
          })),
        );
      } catch (error) {
        console.error("Error fetching decorations:", error);
      }
    };

    fetchDecorations();
  }, []);

  const handleAddType = (index, type) => {
    const updatedList = [...list];
    const newEntry = {
      type: "",
      qty: 0,
      product_id: updatedList[index]?.product_id,
      shape_id: updatedList[index]?.shape_id,
      glaze_id: updatedList[index]?.glaze_id,
      decoration_code: updatedList[index]?.decoration_code,
      decoration_name: updatedList[index]?.decoration_name,
    };

    if (type === "defect") {
      updatedList[index].defects = [
        ...(updatedList[index].defects || []),
        newEntry,
      ];
    } else if (type === "repair") {
      updatedList[index].repair_items = [
        ...(updatedList[index].repair_items || []),
        newEntry,
      ];
    }

    setList(updatedList);
    setOriginalList(updatedList);

    // ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const handleTypeChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defects[subIndex].type = value;
    } else if (type === "repair") {
      updatedList[index].repair_items[subIndex].type = value;
    }
    setList(updatedList);
    setOriginalList(updatedList);

    // ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const handleQtyChange = (index, subIndex, value, type) => {
    const updatedList = [...list];
    const quantity = parseInt(value) || 0;
    if (type === "defect") {
      updatedList[index].defects[subIndex].qty = quantity;
    } else if (type === "repair") {
      updatedList[index].repair_items[subIndex].qty = quantity;
    }
    setList(updatedList);

    // ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
    // Also update originalList
    setOriginalList(updatedList);
  };

  const handleRemoveType = (index, subIndex, type) => {
    const updatedList = [...list];
    if (type === "defect") {
      updatedList[index].defects.splice(subIndex, 1);
    } else if (type === "repair") {
      updatedList[index].repair_items.splice(subIndex, 1);
    }
    setList(updatedList);
    setOriginalList(updatedList);

    // ADD THIS: Update the global map
    const itemId = updatedList[index].id;
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // const handleDecorationChange = (index, value) => {
  //   const updatedList = [...list];
  //   const itemId = updatedList[index].id;
  //   updatedList[index].decoration = value;
  //   setList(updatedList);
  //   setOriginalList(updatedList);

  //   // Update the global map
  //   setAllItemsWithInput((prevMap) => {
  //     const newMap = new Map(prevMap);
  //     newMap.set(itemId, { ...updatedList[index] });
  //     return newMap;
  //   });
  // };

  // Modified handleDecorationChange function
  const handleDecorationChange = (index, value) => {
    const updatedList = [...list];
    const itemId = updatedList[index].id;
    updatedList[index].decoration = value;
    setList(updatedList);
    setOriginalList(updatedList);

    // Mark this item as having a user selection
    setUserSelectedDecorations((prev) => {
      const newSet = new Set(prev);
      newSet.add(itemId);
      return newSet;
    });

    // Update the global map
    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(itemId, { ...updatedList[index] });
      return newMap;
    });
  };

  const getGroupKey = (item) => {
    const pid = item?.product_id ?? "";
    const sid = item?.shape_id ?? "";
    const gid = item?.glaze_id ?? "";
    const dcode = item?.decoration_code ?? "";
    const dname = item?.decoration_name ?? "";
    return `${pid}|${sid}|${gid}|${dcode}|${dname}`;
  };

  const getGroupIndices = (items, target) => {
    const key = getGroupKey(target);
    const indices = [];
    for (let i = 0; i < items.length; i++) {
      if (getGroupKey(items[i]) === key) indices.push(i);
    }
    return indices;
  };

  const getGroupSize = (item) => {
    const key = getGroupKey(item);
    let count = 0;
    for (let i = 0; i < list.length; i++) {
      if (getGroupKey(list[i]) === key) count++;
    }
    return count;
  };

  const recomputeGroupInventory = (items) => {
    const map = new Map();
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const key = getGroupKey(it);
      if (!map.has(key)) {
        map.set(key, {
          baseExport: Number(it.current_stock_qty_export_class) || 0,
          baseA: Number(it.current_stock_qty_a_class) || 0,
          baseB: Number(it.current_stock_qty_b_class) || 0,
          baseC: Number(it.current_stock_qty_c_class) || 0,
          baseInner: Number(it.current_stock_inner_qty) || 0,
          baseMaster: Number(it.current_stock_master_qty) || 0,
          sumExport: 0,
          sumExportLoss: 0,
          sumA: 0,
          sumALoss: 0,
          sumB: 0,
          sumBLoss: 0,
          sumC: 0,
          sumCLoss: 0,
          sumInner: 0,
          sumInnerLoss: 0,
          sumMaster: 0,
          sumMasterLoss: 0,
        });
      } else {
        const g = map.get(key);
        g.baseExport = Math.min(
          g.baseExport,
          Number(it.current_stock_qty_export_class) || 0,
        );
        g.baseA = Math.min(g.baseA, Number(it.current_stock_qty_a_class) || 0);
        g.baseB = Math.min(g.baseB, Number(it.current_stock_qty_b_class) || 0);
        g.baseC = Math.min(g.baseC, Number(it.current_stock_qty_c_class) || 0);
        g.baseInner = Math.min(
          g.baseInner,
          Number(it.current_stock_inner_qty) || 0,
        );
        g.baseMaster = Math.min(
          g.baseMaster,
          Number(it.current_stock_master_qty) || 0,
        );
      }
      const g2 = map.get(key);
      g2.sumExport += Number(it.qty_export) || 0;
      g2.sumExportLoss += Number(it.after_production_loss_qty_export) || 0;
      g2.sumA += Number(it.qty_a_class) || 0;
      g2.sumALoss += Number(it.after_production_loss_qty_a_class) || 0;
      g2.sumB += Number(it.qty_b_class) || 0;
      g2.sumBLoss += Number(it.after_production_loss_qty_b_class) || 0;
      g2.sumC += Number(it.qty_c_class) || 0;
      g2.sumCLoss += Number(it.after_production_loss_qty_c_class) || 0;
      g2.sumInner += Number(it.inner_transfer_qty) || 0;
      g2.sumInnerLoss += Number(it.after_production_loss_qty_inner) || 0;
      g2.sumMaster += Number(it.master_transfer_qty) || 0;
      g2.sumMasterLoss += Number(it.after_production_loss_qty_master) || 0;
    }
    for (const [k, g] of map.entries()) {
      g.availableExport = Math.max(
        0,
        (Number(g.baseExport) || 0) -
          ((Number(g.sumExport) || 0) + (Number(g.sumExportLoss) || 0)),
      );
      g.availableA = Math.max(
        0,
        (Number(g.baseA) || 0) -
          ((Number(g.sumA) || 0) + (Number(g.sumALoss) || 0)),
      );
      g.availableB = Math.max(
        0,
        (Number(g.baseB) || 0) -
          ((Number(g.sumB) || 0) + (Number(g.sumBLoss) || 0)),
      );
      g.availableC = Math.max(
        0,
        (Number(g.baseC) || 0) -
          ((Number(g.sumC) || 0) + (Number(g.sumCLoss) || 0)),
      );
      g.availableInner = Math.max(
        0,
        (Number(g.baseInner) || 0) -
          ((Number(g.sumInner) || 0) + (Number(g.sumInnerLoss) || 0)),
      );
      g.availableMaster = Math.max(
        0,
        (Number(g.baseMaster) || 0) -
          ((Number(g.sumMaster) || 0) + (Number(g.sumMasterLoss) || 0)),
      );
    }
    return map;
  };

  useEffect(() => {
    setGroupInventory(recomputeGroupInventory(list));
  }, [list]);

  const getGroupAvailable = (item, type) => {
    const key = getGroupKey(item);
    const g = groupInventory.get(key);
    if (!g) {
      const tmp = recomputeGroupInventory(list).get(key);
      if (!tmp) return 0;
      switch (type) {
        case "export":
          return tmp.availableExport;
        case "a":
          return tmp.availableA;
        case "b":
          return tmp.availableB;
        case "c":
          return tmp.availableC;
        case "inner":
          return tmp.availableInner;
        case "master":
          return tmp.availableMaster;
        default:
          return 0;
      }
    }
    switch (type) {
      case "export":
        return g.availableExport;
      case "a":
        return g.availableA;
      case "b":
        return g.availableB;
      case "c":
        return g.availableC;
      case "inner":
        return g.availableInner;
      case "master":
        return g.availableMaster;
      default:
        return 0;
    }
  };

  const LOSS_PAIR = {
    after_production_loss_qty_a_class: "qty_a_class",
    after_production_loss_qty_b_class: "qty_b_class",
    after_production_loss_qty_c_class: "qty_c_class",
    after_production_loss_qty_export: "qty_export",
    after_production_loss_qty_inner: "inner_transfer_qty",
    after_production_loss_qty_master: "master_transfer_qty",
  };

  // FIXED: Updated handleInputChange to properly handle item IDs
  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedList = [...list];
    let inputValue = value === "" ? 0 : parseFloat(value);
    if (Number.isNaN(inputValue)) inputValue = 0;

    const target = updatedList[index];
    const key = getGroupKey(target);

    const qtyFields = new Set([
      "qty_a_class",
      "qty_b_class",
      "qty_c_class",
      "qty_export",
      "inner_transfer_qty",
      "master_transfer_qty",
    ]);

    let newValue = inputValue;
    if (qtyFields.has(name)) {
      let baseStockKey = null;
      if (name === "qty_a_class") baseStockKey = "current_stock_qty_a_class";
      else if (name === "qty_b_class")
        baseStockKey = "current_stock_qty_b_class";
      else if (name === "qty_c_class")
        baseStockKey = "current_stock_qty_c_class";
      else if (name === "qty_export")
        baseStockKey = "current_stock_qty_export_class";
      else if (name === "inner_transfer_qty")
        baseStockKey = "current_stock_inner_qty";
      else if (name === "master_transfer_qty")
        baseStockKey = "current_stock_master_qty";

      let base = Number(target[baseStockKey]) || 0;
      let sumOther = 0;
      let sumLossGroup = 0;
      for (let i = 0; i < updatedList.length; i++) {
        const it = updatedList[i];
        if (getGroupKey(it) !== key) continue;
        base = Math.min(base, Number(it[baseStockKey]) || base);
        if (i !== index) sumOther += Number(it[name]) || 0;
        if (name === "qty_a_class")
          sumLossGroup += Number(it.after_production_loss_qty_a_class) || 0;
        else if (name === "qty_b_class")
          sumLossGroup += Number(it.after_production_loss_qty_b_class) || 0;
        else if (name === "qty_c_class")
          sumLossGroup += Number(it.after_production_loss_qty_c_class) || 0;
        else if (name === "qty_export")
          sumLossGroup += Number(it.after_production_loss_qty_export) || 0;
        else if (name === "inner_transfer_qty")
          sumLossGroup += Number(it.after_production_loss_qty_inner) || 0;
        else if (name === "master_transfer_qty")
          sumLossGroup += Number(it.after_production_loss_qty_master) || 0;
      }
      const allowed = Math.max(
        0,
        (Number(base) || 0) -
          ((Number(sumOther) || 0) + (Number(sumLossGroup) || 0)),
      );
      newValue = Math.max(0, Math.min(inputValue, allowed));
      updatedList[index][name] = newValue;
    } else if (LOSS_PAIR[name]) {
      let baseStockKey = null;
      if (name === "after_production_loss_qty_a_class")
        baseStockKey = "current_stock_qty_a_class";
      else if (name === "after_production_loss_qty_b_class")
        baseStockKey = "current_stock_qty_b_class";
      else if (name === "after_production_loss_qty_c_class")
        baseStockKey = "current_stock_qty_c_class";
      else if (name === "after_production_loss_qty_export")
        baseStockKey = "current_stock_qty_export_class";
      else if (name === "after_production_loss_qty_inner")
        baseStockKey = "current_stock_inner_qty";
      else if (name === "after_production_loss_qty_master")
        baseStockKey = "current_stock_master_qty";

      let base = Number(target[baseStockKey]) || 0;
      let sumQtyGroup = 0;
      let sumOtherLoss = 0;
      for (let i = 0; i < updatedList.length; i++) {
        const it = updatedList[i];
        if (getGroupKey(it) !== key) continue;
        base = Math.min(base, Number(it[baseStockKey]) || base);
        if (name === "after_production_loss_qty_a_class")
          sumQtyGroup += Number(it.qty_a_class) || 0;
        else if (name === "after_production_loss_qty_b_class")
          sumQtyGroup += Number(it.qty_b_class) || 0;
        else if (name === "after_production_loss_qty_c_class")
          sumQtyGroup += Number(it.qty_c_class) || 0;
        else if (name === "after_production_loss_qty_export")
          sumQtyGroup += Number(it.qty_export) || 0;
        else if (name === "after_production_loss_qty_inner")
          sumQtyGroup += Number(it.inner_transfer_qty) || 0;
        else if (name === "after_production_loss_qty_master")
          sumQtyGroup += Number(it.master_transfer_qty) || 0;

        const lossVal =
          name === "after_production_loss_qty_a_class"
            ? Number(it.after_production_loss_qty_a_class) || 0
            : name === "after_production_loss_qty_b_class"
              ? Number(it.after_production_loss_qty_b_class) || 0
              : name === "after_production_loss_qty_c_class"
                ? Number(it.after_production_loss_qty_c_class) || 0
                : name === "after_production_loss_qty_inner"
                  ? Number(it.after_production_loss_qty_inner) || 0
                  : name === "after_production_loss_qty_master"
                    ? Number(it.after_production_loss_qty_master) || 0
                    : Number(it.after_production_loss_qty_export) || 0;
        if (i !== index) sumOtherLoss += lossVal;
      }
      const allowed = Math.max(
        0,
        (Number(base) || 0) -
          ((Number(sumQtyGroup) || 0) + (Number(sumOtherLoss) || 0)),
      );
      newValue = Math.max(0, Math.min(inputValue, allowed));
      updatedList[index][name] = newValue;
    } else {
      updatedList[index][name] = newValue;
    }

    setList(updatedList);

    setAllItemsWithInput((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(updatedList[index].id, { ...updatedList[index] });
      return newMap;
    });

    setOriginalList(updatedList);
  };

  const getRandomDecoration = () => {
    const randomIndex = Math.floor(Math.random() * dummyDecorations.length);
    return dummyDecorations[randomIndex];
  };

  const formSubmit = () => {
    checkRequiredFields();
    const allItemsArray = Array.from(allItemsWithInput.values());
    const formData = {
      ...inputs,
      items: allItemsArray,
    };

    // ADDED: confirmation prompt before submitting
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit this transfer?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      // if (!result.isConfirmed) return;
      if (!result.isConfirmed) {
        setIsSubmitting(false); // ADDED: reappear on cancel
        return;
      }

      Http.post(`/production-transfer`, formData)
        .then((res) => {
          navigate("/transfer-art", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    });
  };
  const cols = [{ field: "name", header: "Item" }];
  // FIXED: Updated handlePlanningChange to properly preserve user input
  // const handlePlanningChange = async (planningId, page = 1) => {
  //   if (!planningId) return;

  //   setInputs((prevInputs) => ({
  //     ...prevInputs,
  //     planning_id: planningId,
  //   }));

  //   try {
  //     const response = await Http.get(
  //       `/planning/${planningId}?page=${page}&limit=${pagination.per_page}`
  //     );

  //     console.log("Planning response:", response.data.items);

  //     const planningItems = response.data.items.map((item) => {
  //       // Check if this specific item (by ID) already has user input
  //       const existingItem = allItemsWithInput.get(item.id);

  //       const baseItem = {
  //         id: item?.id,
  //         type: "packing",
  //         product_id: item?.product_id,
  //         product_name: item?.product?.name,
  //         shape: item?.shape?.name,
  //         planning_qty: item?.qty,
  //         production_work_order: item?.production_work_order?.receipt_no,
  //         production_work_order_id: item?.production_work_order?.id,
  //         production_work_order_item_id: item?.production_work_order_item_id,
  //         planning_id: item?.planning_id,
  //         company: item?.production_work_order?.company?.name,
  //         product_code: item?.product?.code,
  //         set_id: item?.set_id,
  //         set_name: item?.set_item?.name,
  //         opening_balance: 0,
  //         weight: item?.weight,
  //         transfer_qty: 0,
  //         received_qty_class_exp: item.received_qty_class?.receive_qty_export_class,
  //         received_qty_class_a: item?.received_qty_class?.a_class,
  //         received_qty_class_b: item?.received_qty_class?.b_class,
  //         received_qty_class_c: item?.received_qty_class?.c_class,
  //         receive_inner_qty: item?.received_qty_class?.receive_inner_qty,
  //         receive_master_qty: item?.received_qty_class?.receive_master_qty,
  //         transfered_qty_class_exp: item?.transfered_qty_class?.delivery_qty_export_class,
  //         transfered_qty_class_a: item?.transfered_qty_class?.a_class,
  //         transfered_qty_class_b: item?.transfered_qty_class?.b_class,
  //         transfered_qty_class_c: item?.transfered_qty_class?.c_class,
  //         delivery_inner_qty: item?.transfered_qty_class?.delivery_inner_qty,
  //         delivery_master_qty: item?.transfered_qty_class?.delivery_master_qty,
  //         decoration_code: item?.production_work_order_item?.decoration?.code,
  //         decoration_name: item?.production_work_order_item?.decoration?.decoration_name,
  //         glaze_color_name: item?.production_work_order_item?.color?.colour_name,
  //         glaze_color: item?.production_work_order_item?.color?.id,
  //         closing_balance: item?.qty,
  //         remarks_delivery: "",
  //         opening_qty: item?.opening_qty,
  //         total_received_qty: item?.total_received_qty,
  //         total_transfered_qty: item?.total_transfered_qty,
  //         company_id: item?.production_work_order?.company_id,
  //         transfered_item_decoration: item?.transfered_item_decoration,
  //         // Initialize quantity fields to 0 for new items
  //         qty_a_class: 0,
  //         qty_b_class: 0,
  //         qty_c_class: 0,
  //         qty_export: 0,
  //       };

  //       // If user has previously entered data for this specific item ID, use that
  //       if (existingItem) {
  //         return existingItem;
  //       } else {
  //         // Store the new item in the map
  //         return baseItem;
  //       }
  //     });

  //     console.log(planningItems);
  //     setList(planningItems);
  //     setOriginalList(planningItems);
  //     setPagination(response.data.pagination);

  //     // Update the global map with new items (only if they don't already exist)
  //     setAllItemsWithInput(prevMap => {
  //       const newMap = new Map(prevMap);
  //       planningItems.forEach(item => {
  //         if (!newMap.has(item.id)) {
  //           newMap.set(item.id, item);
  //         }
  //       });
  //       return newMap;
  //     });
  //   } catch (error) {
  //     console.error("Error fetching products for planning:", error);
  //     Swal.fire(
  //       "Error!",
  //       "Failed to fetch products for the selected planning.",
  //       "error"
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleSearchProduct = async (e, page = 1) => {
  //   const searchValue = e.target.value;
  //   setSearchProducts(searchValue);
  //   const planningId = inputs.planning_id;
  //   if (!searchValue.trim()) {
  //     // setList(originalList);
  //     handlePlanningChange(planningId, page);
  //   } else {
  //     if (role === "decoration_firing" || role === "decoration_local" || role == "decoration_export") {
  //       const response = await Http.post(`/search-products?page=${page}&limit=${pagination.per_page}`, { search: searchValue, planningId: planningId });

  //       const planningItems = response.data.items.map((item) => {
  //         // Check if this specific item (by ID) already has user input
  //         const existingItem = allItemsWithInput.get(item.id);

  //         const baseItem = {
  //           id: item?.id,
  //           type: "packing",
  //           product_id: item?.product_id,
  //           product_name: item?.product?.name,
  //           shape: item?.shape?.name,
  //           planning_qty: item?.qty,
  //           production_work_order: item?.production_work_order?.receipt_no,
  //           production_work_order_id: item?.production_work_order?.id,
  //           production_work_order_item_id: item?.production_work_order_item_id,
  //           planning_id: item?.planning_id,
  //           company: item?.production_work_order?.company?.name,
  //           product_code: item?.product?.code,
  //           set_id: item?.set_id,
  //           set_name: item?.set_item?.name,
  //           opening_balance: 0,
  //           weight: item?.weight,
  //           transfer_qty: 0,
  //           received_qty_class_exp: item.received_qty_class?.receive_qty_export_class,
  //           received_qty_class_a: item?.received_qty_class?.a_class,
  //           received_qty_class_b: item?.received_qty_class?.b_class,
  //           received_qty_class_c: item?.received_qty_class?.c_class,
  //           receive_inner_qty: item?.received_qty_class?.receive_inner_qty,
  //           receive_master_qty: item?.received_qty_class?.receive_master_qty,
  //           transfered_qty_class_exp: item?.transfered_qty_class?.delivery_qty_export_class,
  //           transfered_qty_class_a: item?.transfered_qty_class?.a_class,
  //           transfered_qty_class_b: item?.transfered_qty_class?.b_class,
  //           transfered_qty_class_c: item?.transfered_qty_class?.c_class,
  //           delivery_inner_qty: item?.transfered_qty_class?.delivery_inner_qty,
  //           delivery_master_qty: item?.transfered_qty_class?.delivery_master_qty,
  //           decoration_code: item?.production_work_order_item?.decoration?.code,
  //           decoration_name: item?.production_work_order_item?.decoration?.decoration_name,
  //           glaze_color_name: item?.production_work_order_item?.color?.colour_name,
  //           glaze_color: item?.production_work_order_item?.color?.id,
  //           closing_balance: item?.qty,
  //           remarks_delivery: "",
  //           opening_qty: item?.opening_qty,
  //           total_received_qty: item?.total_received_qty,
  //           total_transfered_qty: item?.total_transfered_qty,
  //           company_id: item?.production_work_order?.company_id,
  //           transfered_item_decoration: item?.transfered_item_decoration,
  //           // Initialize quantity fields to 0 for new items
  //           qty_a_class: 0,
  //           qty_b_class: 0,
  //           qty_c_class: 0,
  //           qty_export: 0,
  //         };

  //         // If user has previously entered data for this specific item ID, use that
  //         if (existingItem) {
  //           return existingItem;
  //         } else {
  //           // Store the new item in the map
  //           return baseItem;
  //         }
  //       });

  //       console.log(planningItems);
  //       setList(planningItems);
  //       setOriginalList(planningItems);
  //       setPagination(response.data.pagination);

  //     } else {
  //       const searchProduct = originalList.filter((item) =>
  //         ["product_name", "shape", "company", "production_work_order"].some(
  //           (key) => item[key]?.toLowerCase().includes(searchValue.toLowerCase())
  //         )
  //       );
  //       setList(searchProduct);
  //     }

  //   }
  // };
  useEffect(() => {
    if (inputs.planning_id) {
      handlePlanningChange(inputs.planning_id);
    }
  }, [inputs.planning_id]);
  const handlePlanningChange = async (
    planningId,
    page = 1,
    productName = "",
  ) => {
    if (!planningId) return;
    // Set loading state to true when planning changes
    setLoading(true);
    // Reset all form data when planning changes
    // setList([]); // Clear the current list
    // setOriginalList([]); // Clear original list
    // setAllItemsWithInput(new Map()); // Clear the items map
    // setSearchProducts(""); // Clear search input
    setInputs((prevInputs) => ({
      ...prevInputs,
      planning_id: planningId,
    }));

    try {
      const response = await Http.get(
        `/planning/${planningId}?page=${page}&limit=${pagination.per_page}&product_name=${productName}`,
      );
      const planningItems = response.data.items.map((item) => {
        const existingItem = allItemsWithInput.get(item.id);

        const baseItem = {
          id: item?.id,
          type: "packing",
          product_id: item?.product_id,
          shape_id: item?.shape_id,
          glaze_id: item?.glaze_id,
          decal_code: item?.production_work_order_item?.decoration?.code,
          decoration_code: item?.decoration_code,
          decoration_name: item?.decoration_name,
          product_name: item?.product?.name,
          shape: item?.shape?.name,
          planning_qty: item?.qty,
          production_work_order: item?.production_work_order?.receipt_no,
          production_work_order_id: item?.production_work_order?.id,
          production_work_order_item_id: item?.production_work_order_item_id,
          planning_id: item?.planning_id,
          company: item?.production_work_order?.company?.name,
          product_code: item?.product?.code,
          set_id: item?.set_id,
          set_name: item?.set_item?.name,
          opening_balance: 0,
          weight: item?.weight,
          transfer_qty: 0,

          current_stock_qty_export_class: item?.current_stock_qty_export_class,
          current_stock_qty_a_class: item?.current_stock_qty_a_class,
          current_stock_qty_b_class: item?.current_stock_qty_b_class,
          current_stock_qty_c_class: item?.current_stock_qty_c_class,
          current_stock_inner_qty: item?.current_stock_inner_qty,
          current_stock_master_qty: item?.current_stock_master_qty,

          received_qty_class_exp:
            // (Number(item?.received_qty_class?.receive_qty_export_class) || 0) +
            Number(item?.current_stock_qty_export_class) || 0,
          received_qty_class_a:
            // (Number(item?.received_qty_class?.a_class) || 0) +
            Number(item?.current_stock_qty_a_class) || 0,
          received_qty_class_b:
            // (Number(item?.received_qty_class?.b_class) || 0) +
            Number(item?.current_stock_qty_b_class) || 0,
          received_qty_class_c:
            // (Number(item?.received_qty_class?.c_class) || 0) +
            Number(item?.current_stock_qty_c_class) || 0,
          receive_inner_qty:
            // (Number(item?.received_qty_class?.receive_inner_qty) || 0) +
            Number(item?.current_stock_inner_qty) || 0,
          receive_master_qty:
            // (Number(item?.received_qty_class?.receive_master_qty) || 0) +
            Number(item?.current_stock_master_qty) || 0,
          transfered_qty_class_exp:
            item?.transfered_qty_class?.delivery_qty_export_class,
          transfered_qty_class_a: item?.transfered_qty_class?.a_class,
          transfered_qty_class_b: item?.transfered_qty_class?.b_class,
          transfered_qty_class_c: item?.transfered_qty_class?.c_class,
          delivery_inner_qty: item?.transfered_qty_class?.delivery_inner_qty,
          delivery_master_qty: item?.transfered_qty_class?.delivery_master_qty,
          // decoration_code: item?.production_work_order_item?.decoration?.code,
          // decoration_name: item?.production_work_order_item?.decoration_name,
          glaze_color_name:
            item?.production_work_order_item?.color?.colour_name,
          glaze_color: item?.production_work_order_item?.color?.id,
          closing_balance: item?.qty,
          remarks_delivery: "",
          opening_qty: item?.opening_qty,
          total_received_qty: item?.total_received_qty,
          total_transfered_qty: item?.total_transfered_qty,
          company_id: item?.production_work_order?.company_id,
          transfered_item_decoration: item?.transfered_item_decoration,
          qty_a_class: 0,
          qty_b_class: 0,
          qty_c_class: 0,
          qty_export: 0,
          inner_transfer_qty: 0,
          master_transfer_qty: 0,
          after_production_loss_qty_a_class: 0,
          after_production_loss_qty_b_class: 0,
          after_production_loss_qty_c_class: 0,
          after_production_loss_qty_export: 0,
          after_production_loss_qty_inner: 0,
          after_production_loss_qty_master: 0,
          // IMPORTANT: Initialize repair_items and defects if they don't exist
          repair_items: [],
          defects: [],
          status: item?.production_work_order?.status,
        };

        // return existingItem || baseItem;
        // CRITICAL FIX: If existingItem has repair/defect data, preserve it completely
        if (existingItem) {
          return {
            ...baseItem,
            ...existingItem, // This will override baseItem with all existing data
            // Ensure repair_items and defects are preserved
            repair_items: existingItem.repair_items || [],
            defects: existingItem.defects || [],
          };
        }

        return baseItem;
      });

      setList(planningItems);
      setOriginalList(planningItems);
      setPagination(response.data.pagination);

      // setAllItemsWithInput(prevMap => {
      //   const newMap = new Map(prevMap);
      //   planningItems.forEach(item => {
      //     if (!newMap.has(item.id)) {
      //       newMap.set(item.id, item);
      //     }
      //   });
      //   return newMap;
      // });

      // Update the global map - make sure to preserve existing data
      setAllItemsWithInput((prevMap) => {
        const newMap = new Map(prevMap);
        planningItems.forEach((item) => {
          // Only update if item doesn't exist in map, or merge with existing data
          const existingMapItem = newMap.get(item.id);
          if (existingMapItem) {
            // Merge existing data with new data, giving priority to existing user inputs
            newMap.set(item.id, {
              ...item,
              ...existingMapItem,
              // Ensure repair and defect arrays are preserved
              repair_items:
                existingMapItem.repair_items || item.repair_items || [],
              defects: existingMapItem.defects || item.defects || [],
            });
          } else {
            newMap.set(item.id, item);
          }
        });
        return newMap;
      });
    } catch (error) {
      console.error("Error fetching products for planning:", error);
      Swal.fire(
        "Error!",
        "Failed to fetch products for the selected planning.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearch = useCallback(
    async (searchValue, page = 1) => {
      setLoading(true);
      setShowPagination(true);
      const planningId = inputs.planning_id;

      if (
        [
          "decoration_firing",
          "decoration_local",
          "decoration_export",
          "packing_local",
          "packing_export",
        ].includes(role)
      ) {
        try {
          const response = await Http.get(
            `/planning/${planningId}?page=${page}&limit=${pagination.per_page || 100}&product_name=${searchValue}`,
          );

          const searchLower = searchValue.toLowerCase();

          const planningItems = response.data.items
            .filter((item) => {
              const productMatch = item?.product?.name
                ?.toLowerCase()
                ?.includes(searchLower);
              const shapeMatch = item?.shape?.name
                ?.toLowerCase()
                ?.includes(searchLower);
              const companyMatch = item?.production_work_order?.company?.name
                ?.toLowerCase()
                ?.includes(searchLower);
              const workOrderMatch = item?.production_work_order?.receipt_no
                ?.toLowerCase()
                ?.includes(searchLower);

              // Prioritize product name match first, fallback to others if not matched
              return (
                productMatch ||
                (!productMatch &&
                  (shapeMatch || companyMatch || workOrderMatch))
              );
            })
            .map((item) => {
              const existingItem = allItemsWithInput.get(item.id);
              const baseItem = {
                id: item?.id,
                type: "packing",
                product_id: item?.product_id,
                shape_id: item?.shape_id,
                decal_code: item?.production_work_order_item?.decoration?.code,
                glaze_id: item?.production_work_order_item?.glaze?.id,
                decoration_code:
                  item?.production_work_order_item?.decoration_code,
                decoration_name:
                  item?.production_work_order_item?.decoration_name,
                product_name: item?.product?.name,
                shape: item?.shape?.name,
                planning_qty: item?.qty,
                production_work_order: item?.production_work_order?.receipt_no,
                production_work_order_id: item?.production_work_order?.id,
                production_work_order_item_id:
                  item?.production_work_order_item_id,
                planning_id: item?.planning_id,
                company: item?.production_work_order?.company?.name,
                product_code: item?.product?.code,
                set_id: item?.set_id,
                set_name: item?.set_item?.name,
                opening_balance: 0,
                weight: item?.weight,
                transfer_qty: 0,

                // ADDED: these were missing, causing "Available" to always compute as 0
                current_stock_qty_export_class:
                  item?.current_stock_qty_export_class,
                current_stock_qty_a_class: item?.current_stock_qty_a_class,
                current_stock_qty_b_class: item?.current_stock_qty_b_class,
                current_stock_qty_c_class: item?.current_stock_qty_c_class,
                current_stock_inner_qty: item?.current_stock_inner_qty,
                current_stock_master_qty: item?.current_stock_master_qty,

                received_qty_class_exp:
                  item.received_qty_class?.receive_qty_export_class,
                received_qty_class_a: item?.received_qty_class?.a_class,
                received_qty_class_b: item?.received_qty_class?.b_class,
                received_qty_class_c: item?.received_qty_class?.c_class,
                receive_inner_qty: item?.received_qty_class?.receive_inner_qty,
                receive_master_qty:
                  item?.received_qty_class?.receive_master_qty,
                transfered_qty_class_exp:
                  item?.transfered_qty_class?.delivery_qty_export_class,
                transfered_qty_class_a: item?.transfered_qty_class?.a_class,
                transfered_qty_class_b: item?.transfered_qty_class?.b_class,
                transfered_qty_class_c: item?.transfered_qty_class?.c_class,
                delivery_inner_qty:
                  item?.transfered_qty_class?.delivery_inner_qty,
                delivery_master_qty:
                  item?.transfered_qty_class?.delivery_master_qty,
                // decoration_code: item?.production_work_order_item?.decoration?.code,
                // decoration_name: item?.production_work_order_item?.decoration_name,
                glaze_color_name:
                  item?.production_work_order_item?.color?.colour_name,
                glaze_color: item?.production_work_order_item?.color?.id,
                closing_balance: item?.qty,
                remarks_delivery: "",
                opening_qty: item?.opening_qty,
                total_received_qty: item?.total_received_qty,
                total_transfered_qty: item?.total_transfered_qty,
                company_id: item?.production_work_order?.company_id,
                transfered_item_decoration: item?.transfered_item_decoration,
                qty_a_class: 0,
                qty_b_class: 0,
                qty_c_class: 0,
                qty_export: 0,
                inner_transfer_qty: 0,
                master_transfer_qty: 0,
                after_production_loss_qty_a_class: 0,
                after_production_loss_qty_b_class: 0,
                after_production_loss_qty_c_class: 0,
                after_production_loss_qty_export: 0,
                after_production_loss_qty_inner: 0,
                after_production_loss_qty_master: 0,
                status: item?.production_work_order?.status,
              };

              return existingItem || baseItem;
            });

          setList(planningItems);
          setOriginalList(planningItems);
          setPagination(response.data.pagination);

          // setPagination(response.data.pagination);
        } catch (err) {
          console.error("Search failed:", err);
          Swal.fire("Error!", "Failed to search products.", "error");
        } finally {
          setLoading(false);
        }
      } else {
        const searchLower = searchValue.toLowerCase();
        const filtered = originalList.filter((item) =>
          ["product_name", "shape", "company", "production_work_order"].some(
            (key) => item[key]?.toLowerCase()?.includes(searchLower),
          ),
        );
        setList(filtered);
        setLoading(false);
      }
    },
    [
      inputs.planning_id,
      allItemsWithInput,
      handlePlanningChange,
      originalList,
      role,
      setList,
      setOriginalList,
      setLoading,
    ],
  );

  const handleSearchProduct = (e, page = 1) => {
    const searchValue = e.target.value;
    setSearchProducts(searchValue);

    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);

    setLoading(true);

    if (!searchValue.trim()) {
      handlePlanningChange(inputs.planning_id, 1, "");
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      debouncedSearch(searchValue.trim(), page);
    }, 1000);
  };

  const handleClickSearchProduct = () => {
    const data = [...list];
    setList(data);
  };

  const handlePlanningImageChange = (e, index) => {
    const { value } = e.target;
    console.log(`Selected planning image for item ${index}:`, value);
  };

  // const handlePageChange = (page) => {
  //   if (page < 1 || page > pagination.last_page) return;
  //   handlePlanningChange(inputs.planning_id, page);
  // };

  // const handlePageChange = (page) => {
  //   if (page < 1 || page > pagination.last_page) return;

  //   // Clear any existing timeout
  //   if (searchTimeoutRef.current) {
  //     clearTimeout(searchTimeoutRef.current);
  //   }

  //   if (searchProducts?.trim()) {
  //     // Call debouncedSearch directly instead of going through handleSearchProduct
  //     debouncedSearch(searchProducts, page);
  //   } else {
  //     handlePlanningChange(inputs.planning_id, page);
  //   }
  // };

  const handlePageChange = (page) => {
    if (page === pagination.current_page) return;

    setLoading(true);
    const planningId = inputs.planning_id;
    const currentSearch = searchProducts?.trim();

    // If there's a search value, use the search function with the new page
    if (currentSearch) {
      // Clear any existing timeout
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }

      // Set a new timeout for the search with the new page
      searchTimeoutRef.current = setTimeout(() => {
        debouncedSearch(currentSearch, page);
      }, 300);
    } else {
      // Otherwise, just fetch the planning data for the new page
      handlePlanningChange(planningId, page);
    }
  };

  const renderPagination = () => {
    const { current_page, last_page } = pagination;
    const pageButtons = [];
    let startPage = Math.max(1, current_page - 2);
    let endPage = Math.min(last_page, startPage + 4);

    if (endPage - startPage < 4) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${
            i === current_page ? "btn-primary" : "btn-outline-primary"
          }`}
          onClick={() => handlePageChange(i)}
          disabled={i === current_page}
        >
          {i}
        </button>,
      );
    }

    return (
      <div className="d-flex align-items-center justify-content-center my-3">
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(1)}
          disabled={current_page === 1}
        >
          First
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page - 1)}
          disabled={current_page === 1}
        >
          Previous
        </button>
        {pageButtons}
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(current_page + 1)}
          disabled={current_page === last_page}
        >
          Next
        </button>
        <button
          className="btn btn-sm btn-outline-secondary mx-1"
          onClick={() => handlePageChange(last_page)}
          disabled={current_page === last_page}
        >
          Last
        </button>
        <span className="mx-2">
          Page {current_page} of {last_page}
        </span>
      </div>
    );
  };

  // Rest of your component code...
  // (render method, etc.)
  // }

  // export default Create;
  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Deliver</h5>
        </div>
        <div className="am-pagebody  row d-flex justify-content-evenly">
          <div className="card pd-20 pd-sm-40 col-11">
            <h6 className="card-body-title mg-sm-b-30">
              Production and Delivery
            </h6>
            {/* <p>Transfer To Department {inputs.to_department}</p> */}
            {/* <div className="row my-1 mb-2 fixed-header" style={{
              position: "sticky", top: "12%", width: "102.1%", marginBottom: "10px", zIndex: "1000", backgroundColor: "white", transition: "all 0.3s ease-in-out",
              transform: "translateY(0)"
            }}>
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>
              <div className="col-lg">
                <label>Planning</label>
                <select
                  className="form-control"
                  value={inputs.planning_id || ""} // Bind to inputs
                  onChange={(e) => handlePlanningChange(e.target.value)}
                >
                  <option value="">Select Planning</option>
                  {planningOptions.map((planning) => (
                    <option key={planning.id} value={planning.id}>
                      {planning.receipt_no}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              
              <div className="d-flex" style={{
                position: "sticky", top: "14%", width: "98%", marginBottom: "20px", zIndex: "1000", backgroundColor: "white", transition: "all 0.3s ease-in-out",
                transform: "translateY(0)"
              }}>
 
<div className="col-lg my-2">
                  <label>Search Product</label>
                  <input
                    type="search"
                    className="form-control"
                    name="search_product"
                    placeholder="Search Product"
                    onChange={(e) => handleSearchProduct(e)}
                  />
                </div>

                <div className="col-lg">
                  <label>Remarks</label>
                  <textarea
                    className="form-control"
                    name="remarks"
                    value={inputs.remarks}
                  />
                </div>
              </div>
            </div> */}
            <div
              className="row my-1 pt-3 mb-2 fixed-header"
              style={{
                position: "sticky",
                top: "12%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1002",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg">
                <label>Receipt No</label>
                <input
                  type="text"
                  className="form-control"
                  name="receipt_no"
                  value={inputs.receipt_no}
                  disabled
                />
              </div>

              {/* <div className="col-lg">
                <label>Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="date"
                  value={inputs.date}
                  disabled
                />
              </div> */}
              <div className="col-lg">
                <label>Planning</label>
                <select
                  className="form-control"
                  value={inputs.planning_id || ""} // Bind to inputs
                  onChange={(e) => handlePlanningChange(e.target.value)}
                >
                  <option value="">Select Planning</option>
                  {planningOptions.map((planning) => (
                    <option key={planning.id} value={planning.id}>
                      {planning.receipt_no}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Shift <i className="fa fa-star required"></i>
                </label>
                <select
                  className="form-control"
                  name="shift"
                  value={inputs.shift}
                  onChange={handleChange}
                  data-required
                >
                  <option value="">Select Shift</option>
                  <option value="a">A</option>
                  <option value="b">B</option>
                  <option value="c">C</option>
                  <option value="general">General</option>
                </select>
              </div>
              <div className="col-lg">
                <label>
                  Entry Date <i className="fa fa-star required"></i>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="entry_date"
                  value={inputs.entry_date}
                  onChange={handleChange}
                  data-required
                />
              </div>
              {(role === "packing_local" || role === "decoration_local") && (
                <div className="col-lg">
                  <label>Destination</label>
                  <select
                    className="form-control"
                    name="destination_id"
                    value={inputs.destination_id}
                    onChange={handleChange}
                  >
                    <option value="">Select Destination</option>
                    {companies.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* New input fields for packing local and packing export */}
            </div>
            {role === "packing_local" && (
              <div className="row">
                <div className="col-lg">
                  <label>D/O No.</label>
                  <input
                    type="text"
                    className="form-control"
                    name="do_no"
                    value={inputs.do_no}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg">
                  <label>Vehicle No.</label>
                  <input
                    type="text"
                    className="form-control"
                    name="vehicle_no"
                    value={inputs.vehicle_no}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg">
                  <label>Driver &apos;s Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="driver_name"
                    value={inputs.driver_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg">
                  <label>Gate Pass No.</label>
                  <input
                    type="text"
                    className="form-control"
                    name="gate_pass_no"
                    value={inputs.gate_pass_no}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
            <div
              className="row fixed-header pt-3 pb-3"
              style={{
                position: "sticky",
                top: "22%",
                width: "102.1%",
                marginBottom: "10px",
                zIndex: "1000",
                backgroundColor: "white",
                transition: "all 0.3s ease-in-out",
                transform: "translateY(0)",
              }}
            >
              <div className="col-lg-3 my-2">
                <label>Search Product</label>
                <input
                  type="search"
                  className="form-control"
                  name="search_product"
                  placeholder="Search Product"
                  value={searchProducts}
                  onChange={handleSearchProduct}
                  onFocus={handleClickSearchProduct}
                />
              </div>
              {/* <div className="row">
                <label>Transfer To Department {inputs.to_department}</label>
              </div> */}
              <div className="col-lg-3 my-2 ">
                <label>Remarks</label>
                <textarea
                  className="form-control"
                  name="remarks"
                  value={inputs.remarks}
                  onChange={handleChange}
                />
              </div>
              {list?.length > 0 && (
                <>
                  {!isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-primary"
                        onClick={() => {
                          setIsSubmitting(true);
                          formSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                  {isSubmitting && (
                    <div className="col-lg mt-5">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setIsSubmitting(false)}
                      >
                        Regain Submit
                      </button>
                    </div>
                  )}
                  {showPagination === true && (
                    <div className="col-lg-5 mt-4">{renderPagination()}</div>
                  )}
                </>
              )}
            </div>

            {/* Item List */}
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row mt-5">
                  <div className="card-solid">
                    <div className="card-header with-border text-center">
                      <h5 className="card-title mb-0">
                        Items in the Production
                      </h5>
                    </div>
                  </div>
                  <div className="col-lg">
                    <table
                      className="table table-sm"
                      style={{ borderCollapse: "collapse", width: "100%" }}
                    >
                      <thead
                        className="fixed-header"
                        style={{
                          position: "sticky",
                          top: "35%",
                          width: "104%",
                          marginBottom: "10px",
                          zIndex: "1000",
                          backgroundColor: "white",
                          transition: "all 0.3s ease-in-out",
                          transform: "translateY(0)",
                        }}
                      >
                        <tr>
                          <th>Product Name</th>
                          <th>Shape Name</th>
                          {/* <th>Local Decoration</th> */}
                          <th>Company Name</th>
                          <th>Planning Qty</th>
                          {/* <th>Planning Qty</th>
                      {(role === "dfw" ||
                        role === "decoration_export" ||
                        role === "packing_export") && <th>Rec Exp</th>}
                      {(role === "dfw" ||
                        role === "decoration_local" ||
                        role === "packing_local") && (
                        <>
                          <th>Rec A</th>
                          <th>Rec B</th>
                          <th>Rec C</th>
                        </>
                      )}
                      {(role === "dfw" ||
                        role === "decoration_export" ||
                        role === "packing_export") && <th>Tr Exp</th>}
                      {(role === "dfw" ||
                        role === "decoration_local" ||
                        role === "packing_local") && (
                        <>
                          <th>Tr A</th>
                          <th>Tr B</th>
                          <th>Tr C</th>
                        </>
                      )}
                      <th>Decoration</th>

                      <th>Opening Balance</th>

                      <th>Select Qty</th> */}
                          
                          {(role === "dfw" ||
                            role === "decoration_firing" ||
                            role === "packing_export" ||
                            role === "decoration_export") && (
                            <th>Export Class</th>
                          )}

                          {(role === "dfw" ||
                            role === "decoration_firing" ||
                            role === "packing_local" ||
                            role === "decoration_local") && (
                            <>
                              <th>A Class</th>
                              <th>B Class</th>
                              <th>C Class</th>
                            </>
                          )}

                          {(role === "packing_export" ||
                            role === "sample" ||
                            role == "packing_local") && (
                            <>
                              <th>Inner Qty</th>
                              <th>Master Qty</th>
                            </>
                          )}

                          {/* <th>Defects Qty</th> */}
                          {role !== "decoration_firing" && <th>Repair Qty</th>}

                          {/* <th>Total Produced</th> */}
                          {/* <th>Weight</th> */}
                          {/* <th>Production Qty</th> opening + rcved   */}
                          {/* <th>Transfered</th> */}
                          {/* <th>Transfer</th> */}
                          {/* {(role === "dfw" ||
                        role === "decoration_export" ||
                        role === "packing_export") && <th>Loss Export</th>} */}

                          {/* {(role === "dfw" ||
                        role === "decoration_local" ||
                        role === "packing_local") && (
                        <>
                          <th>Loss A</th>
                          <th>Loss B</th>
                          <th>Loss C</th>
                        </>
                      )} */}
                          {/* <th>Loss Export</th>
                      <th>Loss A</th>
                      <th>Loss B</th>
                      <th>Loss C</th> */}
                          {/* <th>Closing Balance</th> total p - total t */}
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={3} className="text-center">
                              <ProgressSpinner />
                            </td>
                          </tr>
                        ) : list.length < 1 ? (
                          <tr>
                            <td colSpan={12} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        ) : (
                          list.map((item, index) => {
                            const rowKey = item?.id ?? index;
                            const rowStatusClass =
                              role === "decoration_local"
                                ? Number(item?.transfered_qty_class_a || 0) +
                                    Number(item?.transfered_qty_class_b || 0) +
                                    Number(item?.transfered_qty_class_c || 0) >
                                  Number(item?.planning_qty || 0)
                                  ? "bg-warning text-white"
                                  : Number(item?.transfered_qty_class_a || 0) +
                                        Number(
                                          item?.transfered_qty_class_b || 0,
                                        ) +
                                        Number(
                                          item?.transfered_qty_class_c || 0,
                                        ) ===
                                      Number(item?.planning_qty || 0)
                                    ? "bg-success text-white"
                                    : ""
                                : role === "decoration_export"
                                  ? Number(
                                      item?.transfered_qty_class_exp || 0,
                                    ) > Number(item?.planning_qty || 0)
                                    ? "bg-warning text-white"
                                    : Number(
                                          item?.transfered_qty_class_exp || 0,
                                        ) == Number(item?.planning_qty || 0)
                                      ? "bg-success text-white"
                                      : ""
                                  : role === "packing_local"
                                    ? Number(item?.delivery_inner_qty || 0) >
                                      Number(item?.planning_qty || 0)
                                      ? "bg-warning text-white"
                                      : Number(item?.delivery_inner_qty || 0) ==
                                          Number(item?.planning_qty || 0)
                                        ? "bg-success text-white"
                                        : ""
                                    : role === "packing_export"
                                      ? Number(item?.delivery_inner_qty || 0) >
                                        Number(item?.planning_qty || 0)
                                        ? "bg-warning text-white"
                                        : Number(
                                              item?.delivery_inner_qty || 0,
                                            ) == Number(item?.planning_qty || 0)
                                          ? "bg-success text-white"
                                          : ""
                                      : "";

                            return (
                              <tr
                                key={index}
                                {...getRowProps(rowKey, rowStatusClass)}
                                style={{
                                  fontStyle:
                                    item?.status === "on_test"
                                      ? "italic"
                                      : undefined,
                                  fontWeight:
                                    item?.status === "on_test"
                                      ? "700"
                                      : undefined,
                                  border:
                                    item?.status === "on_test"
                                      ? "2px solid rgb(0, 89, 119)"
                                      : undefined,
                                }}
                              >
                                {/* <td>
                            {item.product_name} ({item.shape}) || {item.company}{" "}
                            #{item.production_work_order} <br />
                            <strong>Planning:</strong> {item.planning_qty || 0}{" "}
                            <br />
                            <b>Decoration Code:</b>{" "}
                            {item.decoration_code || "N/A"} ||{" "}
                            <b>Decoration Name:</b>{" "}
                            {item.decoration_name || "N/A"}
                          </td> */}

                                <td className="col-2">
                                  <span
                                    className="badge-danger"
                                    style={{
                                      fontSize: "12px",
                                      borderRadius: "50%",
                                      padding: "1px 2px",
                                    }}
                                  >
                                    {getGroupSize(item) > 1
                                      ? `${getGroupSize(item)}`
                                      : ""}
                                  </span>{" "}
                                  <br />
                                  {item.product_name ?? item.set_name} <br />
                                  {/* <b>Planning Qty:</b> {item.planning_qty} ||{" "} */}
                                  {/* <b>Total Produced:</b> {item.total_production_qty}{" "} */}
                                  {/* <br /> */}
                                  <b>Glaze:</b> (
                                  {item.glaze_color_name || "N/A"}) <br />
                                  {/* {role === "decoration_local" &&
                                item?.company_id === 396 &&
                                item?.decoration_code == null ? (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <b>Decoration:</b>
                                      <Select
                                        className="col-lg-9"
                                        name={`decoration`} // Shared name for each dropdown
                                        value={
                                          decorations.find(
                                            (dec) =>
                                              dec.value === item.decoration
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          const selectedDecorationId =
                                            selectedOption.value;
                                          const selectedDecoration =
                                            decorations.find(
                                              (dec) =>
                                                dec.value ===
                                                selectedDecorationId
                                            );
                                          const updatedList = [...list];
                                          updatedList[index] = {
                                            ...updatedList[index],
                                            decoration: selectedDecorationId, // Update decoration code
                                            decoration_name: selectedDecoration
                                              ? selectedDecoration.decoration_name
                                              : "", // Update decoration name based on selection
                                            decoration_code:
                                              selectedDecorationId
                                                ? selectedDecorationId
                                                : "", // Update decoration code
                                          };
                                          setList(updatedList); // Update the list state

                                          // Update the global map
                                          setAllItemsWithInput((prevMap) => {
                                            const newMap = new Map(prevMap);
                                            newMap.set(updatedList[index].id, {
                                              ...updatedList[index],
                                            });
                                            return newMap;
                                          });
                                        }}
                                        options={decorations} // Assuming decorations is an array of objects with label and value
                                      />
                                    </div>
                                    <b>Decoration Name:</b>{" "}
                                    {item.decoration_name || "N/A"}
                                  </>
                                ) : (
                                  <>
                                    <b>Decoration:</b> (
                                    {item.decoration_code || "N/A"}) <br />
                                    <b>Decoration Name:</b>{" "}
                                    {item.decoration_name || "N/A"}
                                  </>
                                )} */}
                                  {/* // Modified dropdown rendering logic in the table cell  */}
                                  {/* // Replace the existing decoration dropdown section with this: */}
                                  {role === "decoration_local" ||
                                  (role === "decoration_firing" &&
                                    item?.company_id === 396 &&
                                    (item?.decoration_code == null ||
                                      userSelectedDecorations.has(item.id))) ? (
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <b>Decoration:</b>
                                        <Select
                                          className="col-lg-9"
                                          name={`decoration`}
                                          value={
                                            decorations.find(
                                              (dec) =>
                                                dec.value === item.decoration,
                                            ) || null
                                          }
                                          onChange={(selectedOption) => {
                                            const selectedDecorationId =
                                              selectedOption.value;
                                            const selectedDecoration =
                                              decorations.find(
                                                (dec) =>
                                                  dec.value ===
                                                  selectedDecorationId,
                                              );
                                            const updatedList = [...list];
                                            updatedList[index] = {
                                              ...updatedList[index],
                                              decoration: selectedDecorationId,
                                              decoration_name:
                                                selectedDecoration
                                                  ? selectedDecoration.decoration_name
                                                  : "",
                                              decoration_code:
                                                selectedDecorationId
                                                  ? selectedDecorationId
                                                  : "",
                                            };
                                            setList(updatedList);

                                            // Mark as user-selected
                                            setUserSelectedDecorations(
                                              (prev) => {
                                                const newSet = new Set(prev);
                                                newSet.add(
                                                  updatedList[index].id,
                                                );
                                                return newSet;
                                              },
                                            );

                                            // Update the global map
                                            setAllItemsWithInput((prevMap) => {
                                              const newMap = new Map(prevMap);
                                              newMap.set(
                                                updatedList[index].id,
                                                {
                                                  ...updatedList[index],
                                                },
                                              );
                                              return newMap;
                                            });
                                          }}
                                          options={decorations}
                                        />
                                      </div>
                                      <b>Decoration Name:</b>{" "}
                                      {item.decoration_name || "N/A"}
                                    </>
                                  ) : (
                                    <>
                                      <b>Decoration:</b> (
                                      {item?.decal_code || "N/A"}) <br />
                                      <b>Decoration Name:</b>{" "}
                                      {item.decoration_name || "N/A"}
                                    </>
                                  )}
                                </td>
                                <td> {item.shape}</td>
                                {/* <td>
                                {(role === "decoration_firing" ||
                                  role === "packing_local") &&
                                  item?.transfered_item_decoration?.length >
                                    0 && (
                                    // <label>Decoration</label>
                                    <select
                                      className="form-control"
                                      value={item.decoration_code || ""}
                                      name="decoration"
                                      onChange={(e) => {
                                        const selectedDecorationCode =
                                          e.target.value;
                                        const selectedDecoration =
                                          item.transfered_item_decoration.find(
                                            (dec) =>
                                              dec.code ===
                                              selectedDecorationCode
                                          );
                                        const updatedList = [...list];
                                        updatedList[index] = {
                                          ...updatedList[index],
                                          // decoration: selectedDecoration ? selectedDecoration.id : null, // Update decoration ID
                                          decoration_code:
                                            selectedDecorationCode, // Update decoration code
                                          decoration: selectedDecorationCode, // Update decoration code
                                        };
                                        setList(updatedList); // Update the list state
                                      }}
                                    >
                                      <option value="">
                                        Select Decoration
                                      </option>
                                      {item.transfered_item_decoration.map(
                                        (decoration) => (
                                          <option
                                            key={decoration.id}
                                            value={decoration.id}
                                          >
                                            {decoration.code}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  )}
                              </td> */}
                                <td>
                                  {item.company}
                                  <strong>#{item.production_work_order}</strong>
                                </td>
                                <td> {item.planning_qty} </td>
                                {/* <td>{item.planning_qty || 0}</td>

                          {(role === "dfw" ||
                            role === "decoration_export" ||
                            role === "packing_export") && (
                            <td>{item.received_qty_class_exp || 0}</td>
                          )}
                          {(role === "dfw" ||
                            role === "decoration_local" ||
                            role === "packing_local") && (
                            <>
                              <td>{item.received_qty_class_a || 0}</td>
                              <td>{item.received_qty_class_b || 0}</td>
                              <td>{item.received_qty_class_c || 0}</td>
                            </>
                          )}
                          {(role === "dfw" ||
                            role === "decoration_export" ||
                            role === "packing_export") && (
                            <td>{item.transfered_qty_class_exp || 0}</td>
                          )}
                          {(role === "dfw" ||
                            role === "decoration_local" ||
                            role === "packing_local") && (
                            <>
                              <td>{item.transfered_qty_class_a || 0}</td>
                              <td>{item.transfered_qty_class_b || 0}</td>
                              <td>{item.transfered_qty_class_c || 0}</td>
                            </>
                          )} */}

                                {/* <td>1200</td> */}

                                {/* {(role === "decoration_local" ||
                            role === "decoration_export") && (
                            <td>
                              <select
                                className="form-control"
                                name="decoration"
                                value={inputs.decoration}
                                onChange={(e) =>
                                  handleDecorationChange(index, e.target.value)
                                }
                              >
                                <option value="">Select Decoration</option>
                                <option value="Gold Rim">Gold Rim</option>
                                <option value="Platinum Rim">
                                  Platinum Rim
                                </option>
                                <option value="Flower">Flower</option>
                                <option value="Leaf">Leaf</option>
                              </select>
                            </td>
                          )} */}
                                {/* {(role === "dfw" ||
                            role === "packing_local" ||
                            role === "packing_export") && (
                            <td>{item.decoration}</td>
                          )} */}
                                {(role === "dfw" ||
                                  role === "decoration_firing" ||
                                  role === "packing_export" ||
                                  role === "decoration_export") && (
                                  <td
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                      className="col-7"
                                    >
                                      <strong>
                                        Received:{" "}
                                        {item.received_qty_class_exp || 0}
                                      </strong>
                                      <strong>
                                        Transferred:{" "}
                                        {item.transfered_qty_class_exp || 0}
                                      </strong>
                                      <strong>
                                        Available:{" "}
                                        {getGroupAvailable(item, "export")}
                                      </strong>
                                    </div>
                                    <>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control"
                                          name="qty_export"
                                          style={{ width: "100%" }}
                                          value={item.qty_export}
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Produce Exp"
                                        />
                                        <input
                                          type="text"
                                          onInput={(e) =>
                                            (e.target.value =
                                              e.target.value.replace(/\D/g, ""))
                                          }
                                          className="form-control"
                                          name="after_production_loss_qty_export"
                                          style={{ width: "100%" }}
                                          value={
                                            item.after_production_loss_qty_export
                                          }
                                          onChange={(e) =>
                                            handleInputChange(e, index)
                                          }
                                          placeholder="Loss Exp"
                                        />
                                      </div>
                                    </>
                                  </td>
                                )}

                                

                                {(role === "dfw" ||
                                  role === "decoration_firing" ||
                                  role === "packing_local" ||
                                  role === "decoration_local") && (
                                  <>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                          className="col-7"
                                        >
                                          <strong>
                                            Received:{" "}
                                            {item.received_qty_class_a || 0}
                                          </strong>
                                          <strong>
                                            Transferred:{" "}
                                            {item.transfered_qty_class_a || 0}
                                          </strong>
                                          <strong>
                                            Available:{" "}
                                            {getGroupAvailable(item, "a")}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="qty_a_class"
                                            style={{ width: "100%" }}
                                            value={item.qty_a_class}
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Produce A"
                                          />
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="after_production_loss_qty_a_class"
                                            style={{ width: "100%" }}
                                            value={
                                              item.after_production_loss_qty_a_class
                                            }
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Loss A"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                          className="col-7"
                                        >
                                          <strong>
                                            Received:{" "}
                                            {item.received_qty_class_b || 0}
                                          </strong>
                                          <strong>
                                            Transferred:{" "}
                                            {item.transfered_qty_class_b || 0}
                                          </strong>
                                          <strong>
                                            Available:{" "}
                                            {getGroupAvailable(item, "b")}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="qty_b_class"
                                            style={{ width: "100%" }}
                                            value={item.qty_b_class}
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Produce B"
                                          />
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="after_production_loss_qty_b_class"
                                            style={{ width: "100%" }}
                                            value={
                                              item.after_production_loss_qty_b_class
                                            }
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Loss B"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                          className="col-7"
                                        >
                                          <strong>
                                            Received:{" "}
                                            {item.received_qty_class_c || 0}
                                          </strong>
                                          <strong>
                                            Transferred:{" "}
                                            {item.transfered_qty_class_c || 0}
                                          </strong>
                                          <strong>
                                            Available:{" "}
                                            {getGroupAvailable(item, "c")}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="qty_c_class"
                                            style={{ width: "100%" }}
                                            value={item.qty_c_class}
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Produce C"
                                          />
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="after_production_loss_qty_c_class"
                                            style={{ width: "100%" }}
                                            value={
                                              item.after_production_loss_qty_c_class
                                            }
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Loss C"
                                          />
                                        </div>
                                      </div>
                                    </td>

                                    {/* <td>
                                <div className="d-flex justify-content-between">
                                  <strong>
                                    Received Qty:{" "}
                                    {item.received_qty_class_b || 0}
                                  </strong>
                                  <strong>
                                    Transferred Qty:{" "}
                                    {item.transfered_qty_class_b || 0}
                                  </strong>
                                </div>
                                <div className="d-flex flex-column">
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control mb-2"
                                    name="qty_b_class"
                                    value={item.qty_b_class}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Produce B"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_b_class"
                                    value={item.loss_qty_b_class}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss B"
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control mb-2"
                                    name="qty_c_class"
                                    value={item.qty_c_class}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Produce C"
                                  />
                                  <input
                                    type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                    className="form-control"
                                    name="loss_qty_c_class"
                                    value={item.loss_qty_c_class}
                                    onChange={(e) =>
                                      handleInputChange(e, index)
                                    }
                                    placeholder="Loss C"
                                  />
                                </div>
                              </td> */}
                                  </>
                                )}


                                {(role === "packing_export" ||
                                  role === "sample" ||
                                  role == "packing_local") && (
                                  <>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                        }}
                                        className="col-12 "
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <strong>
                                            Received:{" "}
                                            {item.receive_inner_qty || 0}
                                          </strong>
                                          <strong>
                                            Transferred:{" "}
                                            {item.delivery_inner_qty || 0}
                                          </strong>
                                          <strong>
                                            Available:{" "}
                                            {getGroupAvailable(item, "inner")}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="inner_transfer_qty"
                                            style={{ width: "100%" }}
                                            value={item.inner_transfer_qty}
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Inner Qty"
                                          />

                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="after_production_loss_qty_inner"
                                            style={{ width: "100%" }}
                                            value={
                                              item.after_production_loss_qty_inner
                                            }
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Loss Inner"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "space-between",
                                        }}
                                        className="col-12"
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <strong>
                                            Received:{" "}
                                            {item.receive_master_qty || 0}
                                          </strong>
                                          <strong>
                                            Transferred:{" "}
                                            {item.delivery_master_qty || 0}
                                          </strong>
                                          <strong>
                                            Available:{" "}
                                            {getGroupAvailable(item, "master")}
                                          </strong>
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {/* <input
                                      type="text" onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                      className="form-control"
                                      name="inner_transfer_qty"
                                      style={{ width: "100%" }}
                                      value={item.qty_export}
                                      onChange={(e) => handleInputChange(e, index)}
                                      placeholder="Inner Qty"
                                    /> */}
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="master_transfer_qty"
                                            style={{ width: "100%" }}
                                            value={item.master_transfer_qty}
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Master Qty"
                                          />
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control"
                                            name="after_production_loss_qty_master"
                                            style={{ width: "100%" }}
                                            value={
                                              item.after_production_loss_qty_master
                                            }
                                            onChange={(e) =>
                                              handleInputChange(e, index)
                                            }
                                            placeholder="Loss Master"
                                          />
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                )}
                                {/* {(role === "dfw" ||
                            role === "decoration_export" ||
                            role === "packing_export") && (
                            <td>
                              <input
                                type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                className="form-control"
                                name="loss_qty_export"
                                value={item.loss_qty_export}
                                onChange={(e) => handleInputChange(e, index)}
                                placeholder="Loss EXPORT"
                              />
                            </td>
                          )}

                          {(role === "dfw" ||
                            role === "decoration_local" ||
                            role === "packing_local") && (
                            <>
                              <td>
                                <input
                                  type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control"
                                  name="loss_qty_a_class"
                                  value={item.loss_qty_a_class}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="Loss A"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control"
                                  name="loss_qty_b_class"
                                  value={item.loss_qty_b_class}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="Loss B"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control"
                                  name="loss_qty_c_class"
                                  value={item.loss_qty_c_class}
                                  onChange={(e) => handleInputChange(e, index)}
                                  placeholder="Loss C"
                                />
                              </td>
                            </>
                          )} */}
                                {/* <td>
                            {(item.defects || []).map((defect, subIndex) => (
                              <div
                                key={subIndex}
                                className="d-flex align-items-center mb-2"
                              >
                                <select
                                  className="form-control mr-2"
                                  value={defect.type}
                                  onChange={(e) =>
                                    handleTypeChange(
                                      index,
                                      subIndex,
                                      e.target.value,
                                      "defect"
                                    )
                                  }
                                >
                                  <option value="">Select Defect Type</option>
                                  {defectTypes.map((type) => (
                                    <option key={type} value={type}>
                                      {type}
                                    </option>
                                  ))}
                                </select>
                                <input
                                  type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                                  className="form-control mr-2"
                                  value={defect.qty}
                                  onChange={(e) =>
                                    handleQtyChange(
                                      index,
                                      subIndex,
                                      e.target.value,
                                      "defect"
                                    )
                                  }
                                  placeholder="Qty"
                                />
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() =>
                                    handleRemoveType(index, subIndex, "defect")
                                  }
                                >
                                  Remove
                                </button>
                              </div>
                            ))}
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() => handleAddType(index, "defect")}
                            >
                              Add Defect
                            </button>
                          </td> */}

                                {/* Repairs column */}
                                {role != "decoration_firing" && (
                                  <td>
                                    <div className="text-center mb-2">
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={() =>
                                          handleAddType(index, "repair")
                                        }
                                      >
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    </div>
                                    {(item.repair_items || []).map(
                                      (repair, subIndex) => (
                                        <div
                                          key={subIndex}
                                          className="d-flex align-items-center mb-2"
                                        >
                                          <select
                                            className="form-control"
                                            value={repair.type}
                                            onChange={(e) =>
                                              handleTypeChange(
                                                index,
                                                subIndex,
                                                e.target.value,
                                                "repair",
                                              )
                                            }
                                          >
                                            <option value="">
                                              Select Repair Type
                                            </option>
                                            {repairTypes.map((type) => (
                                              <option key={type} value={type}>
                                                {type}
                                              </option>
                                            ))}
                                          </select>
                                          <input
                                            type="text"
                                            onInput={(e) =>
                                              (e.target.value =
                                                e.target.value.replace(
                                                  /\D/g,
                                                  "",
                                                ))
                                            }
                                            className="form-control mx-2"
                                            name="repair_qty"
                                            value={repair.qty || ""}
                                            onChange={(e) =>
                                              handleQtyChange(
                                                index,
                                                subIndex,
                                                e.target.value,
                                                "repair",
                                              )
                                            }
                                            placeholder="Qty"
                                          />
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() =>
                                              handleRemoveType(
                                                index,
                                                subIndex,
                                                "repair",
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash"></i>
                                          </button>
                                        </div>
                                      ),
                                    )}
                                  </td>
                                )}
                                {/* <td>578</td> */}
                                {/* <td>
                            <input
                              type="text"
                              className="form-control"
                              name="weight"
                              value={item.weight}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="production_qty"
                              value={inputs.production_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                                {/* <td>350</td> */}
                                {/* <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="transfer_qty"
                              value={item.transfer_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="return_qty"
                              value={item.return_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                                {/* <td>{item.closing_balance}</td> */}
                                {/* <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="return_qty"
                              value={item.return_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="return_qty"
                              value={item.return_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"  onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
                              className="form-control"
                              name="return_qty"
                              value={item.return_qty}
                              onChange={(e) => handleInputChange(e, index)}
                            />
                          </td> */}
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {showPagination && list.length > 0 && renderPagination()}
              </>
            )}

            {/* {list.length > 0 && (
              <div className="row mt-3">
                <div className="col-3">
                  <button className="btn btn-primary" onClick={formSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
